<ng-container *transloco="let t">
<form #borrowerInfoForm="ngForm" novalidate id="borrowerInfoForm" name="borrowerInfoForm">
  <div class="w-100">
    <div class="row" [ngClass]="{'mb-5': !isMobile}">
      @if (!isHidden('borrower.firstName')) {
        <div class="col-md-3 fv-row">
          <label class="d-flex align-items-center fs-6 fw-bold form-label mb-2">
            <span [ngClass]="{'required': isRequired('borrower.firstName')}">{{getLabel('borrower.firstName', t('wizard.borrowerInfo.firstName'))}}
            </span>
          </label>
          <div class="position-relative">
            <input type="text" class="form-control form-control-solid" [(ngModel)]="borrower.firstName"
              [required]="isRequired('borrower.firstName')" placeholder="" name="firstName"
              [ngClass]="{'is-invalid' : firstName && firstName.touched && firstName.invalid}" #firstName="ngModel" />
            <!-- <div class="invalid-feedback">Please enter a first name.</div> -->
          </div>
        </div>
      }
      @if (!isHidden('borrower.middleName')) {
        <div class="col-md-3 fv-row">
          <label class="d-flex align-items-center fs-6 fw-bold form-label mb-2">
            <span [ngClass]="{'required': isRequired('borrower.middleName')}">{{getLabel('borrower.middleName', t('wizard.borrowerInfo.middleName'))}}
            </span>
          </label>
          <div class="position-relative">
            <input type="text" class="form-control form-control-solid" [(ngModel)]="borrower.middleName"
              [required]="isRequired('borrower.middleName')" placeholder="" name="middleName"
              [attr.maxlength]="restrictMiddleNameToSingleCharacter ? 1 : 50"
              [ngClass]="{'is-invalid' : middleName && middleName.touched && middleName.invalid}" #middleName="ngModel" />
            <!-- <div class="invalid-feedback">Please enter a middle name.</div> -->
          </div>
        </div>
      }
      @if (!isHidden('borrower.lastName')) {
        <div class="col-md-3 fv-row">
          <label class="d-flex align-items-center fs-6 fw-bold form-label mb-2">
            <span [ngClass]="{'required': isRequired('borrower.lastName')}">{{getLabel('borrower.lastName', t('wizard.borrowerInfo.lastName'))}}
            </span>
          </label>
          <div class="position-relative">
            <input type="text" class="form-control form-control-solid" [(ngModel)]="borrower.lastName"
              [required]="isRequired('borrower.lastName')" placeholder="" name="lastName"
              [ngClass]="{'is-invalid' : lastName && lastName.touched && lastName.invalid}" #lastName="ngModel" />
            <!-- <div class="invalid-feedback">Please enter a last name.</div> -->
          </div>
        </div>
      }
      @if (!isHidden('borrower.nameSuffix')) {
        <div class="col-md-3 fv-row">
          <label class="form-label" [ngClass]="{'required': isRequired('borrower.nameSuffix')}">{{getLabel('borrower.nameSuffix', t('wizard.borrowerInfo.suffix'))}}</label>
          <select class="form-select form-select-solid" data-control="select2" name="suffix" #suffix="ngModel" [(ngModel)]="borrower.nameSuffix"
          [ngClass]="{'is-invalid' : suffix && suffix.touched && suffix.invalid}"
          [required]="isRequired('borrower.nameSuffix')">
            <option [ngValue]="null">{{ t('common.selectOne') }}</option>
            <option value="Jr">Jr</option>
            <option value="Sr">Sr</option>
            <option value="I">I</option>
            <option value="II">II</option>
            <option value="III">III</option>
          </select>
        </div>
      }
    </div>
    <div class="row" [ngClass]="{'mb-5': !isMobile}">
      @if (!isHidden('borrower.primaryEmail')) {
        <div class="col-md-6 fv-row">
          <label class="d-flex align-items-center fs-6 fw-bold form-label mb-2"
              [ngClass]="{'required': isRequired('borrower.primaryEmail')}">
            <span>{{getLabel('borrower.primaryEmail', t('wizard.borrowerInfo.email'))}}</span>
          </label>
          <div class="position-relative">
            <input type="text" email trim class="form-control form-control-solid"
              [required]="isRequired('borrower.primaryEmail')"
              [(ngModel)]="borrower.primaryEmail"
              placeholder="" name="email" [ngClass]="{'is-invalid' : email && email.touched && email.invalid}"
              #email="ngModel" />
            <!-- <div class="invalid-feedback">Please enter an e-mail.</div> -->
          </div>
        </div>
      }
      @if (!isHidden('borrower.mobilePhone')) {
        <div class="col-md-3 fv-row">
          <label class="d-flex align-items-center fs-6 fw-bold form-label mb-2">
            <span [ngClass]="{'required': isRequired('borrower.mobilePhone')}">{{getLabel('borrower.mobilePhone', t('wizard.borrowerInfo.phoneNumber'))}}
            </span>
          </label>
          <div class="position-relative">
            <input type="text" class="form-control form-control-solid" [(ngModel)]="borrower.mobilePhone"
              [required]="isRequired('borrower.mobilePhone')" placeholder="" mask='(000) 000-0000' name="phone"
              #phone="ngModel" [ngClass]="{'is-invalid' : phone && phone.touched && phone.invalid}" />
          </div>
        </div>
      }
      @if (!isHidden('borrower.homePhone')) {
        <div class="col-md-3 fv-row">
          <label class="d-flex align-items-center fs-6 fw-bold form-label mb-2">
            <span [ngClass]="{'required': isRequired('borrower.homePhone')}">{{getLabel('borrower.homePhone', t('wizard.borrowerInfo.homePhone'))}}
            </span>
          </label>
          <div class="position-relative">
            <input type="text" class="form-control form-control-solid" [(ngModel)]="borrower.homePhone"
              [required]="isRequired('borrower.homePhone')" placeholder="" mask='(000) 000-0000' name="homePhone"
              #homePhone="ngModel" [ngClass]="{'is-invalid' : homePhone && homePhone.touched && homePhone.invalid}" />
          </div>
        </div>
      }

      @if (!isHidden('borrower.maritalStatus') && !hideCoBorrowerPrivateFields) {
        <div class="col-md-3 fv-row">
          <label class="form-label"
            [ngClass]="{'required': isRequired('borrower.maritalStatus')}">{{getLabel('borrower.maritalStatus', t('wizard.borrowerInfo.maritalStatus'))}}
          </label>
          <select class="form-select form-select-solid" data-control="select2" name="maritalStatus"
            [(ngModel)]="borrower.maritalStatus" (ngModelChange)="onMaritalStatusChanged()"
            [ngClass]="{'is-invalid' : maritalStatus && maritalStatus.touched && maritalStatus.invalid}"
            #maritalStatus="ngModel" [required]="isRequired('borrower.maritalStatus')">
            <option [ngValue]="null">{{ t('common.selectOne') }}</option>
            <option value="Single">{{ t('wizard.borrowerInfo.single') }}</option>
            <option value="Married">{{ t('wizard.borrowerInfo.married') }}</option>
            <option value="Separated">{{ t('wizard.borrowerInfo.separated') }}</option>
            <option value="Other">{{ t('wizard.borrowerInfo.other') }}</option>
          </select>
        </div>
      }

      <!-- WI 24451 — unmarried-partner (URLA Basic Details) group for co-borrowers; shown when Single or Other (OPE-1). -->
      @if (showUnmarriedPartnerGate) {
        <div class="col-md-6 fv-row d-flex align-items-center">
          <div class="form-check form-check-custom form-check-solid">
            <input class="form-check-input" type="checkbox" name="unmarriedAddendum_{{componentId}}"
              [(ngModel)]="unmarriedAddendum" (ngModelChange)="onUnmarriedAddendumChanged()" id="unmarriedAddendum_{{componentId}}"/>
            <label class="form-check-label ms-3" for="unmarriedAddendum_{{componentId}}">
              {{getLabel('borrower.unmarriedAddendum', t('wizard.myInfo.unmarriedPartner'))}}
            </label>
          </div>
        </div>
      }
      @if (showUnmarriedPartnerDetails && !isHidden('borrower.domesticRelationshipType')) {
        <div class="col-md-3 fv-row">
          <label class="form-label" [ngClass]="{'required': isRequired('borrower.domesticRelationshipType')}">{{getLabel('borrower.domesticRelationshipType', t('wizard.myInfo.relationshipType'))}}</label>
          <select class="form-select form-select-solid" data-control="select2" name="domesticRelationshipType_{{componentId}}"
            [(ngModel)]="borrower.domesticRelationshipType" (ngModelChange)="onDomesticRelationshipTypeChanged()" #domesticRelationshipType="ngModel"
            [ngClass]="{'is-invalid' : domesticRelationshipType && domesticRelationshipType.touched && domesticRelationshipType.invalid}"
            [required]="isRequired('borrower.domesticRelationshipType')"
            [attr.data-placeholder]="t('common.selectOne')">
            <option [ngValue]="null">{{ t('common.selectOne') }}</option>
            @for (rt of domesticRelationshipTypeOptions; track rt.value) {
              <option [ngValue]="rt.value">{{ t('enums.domesticRelationshipType.' + rt.value) }}</option>
            }
          </select>
        </div>
      }
      @if (showUnmarriedPartnerDetails && borrower.domesticRelationshipType === DomesticRelationshipTypeEnum.Other && !isHidden('borrower.unmarriedRelationshipTypeOther')) {
        <div class="col-md-3 fv-row">
          <label class="form-label" [ngClass]="{'required': isRequired('borrower.unmarriedRelationshipTypeOther')}">{{getLabel('borrower.unmarriedRelationshipTypeOther', t('wizard.myInfo.specifyRelationshipType'))}}</label>
          <input class="form-control form-control-solid" name="unmarriedRelationshipTypeOther_{{componentId}}"
            [(ngModel)]="borrower.unmarriedRelationshipTypeOther" #unmarriedRelationshipTypeOther="ngModel"
            [placeholder]="t('wizard.myInfo.specifyRelationshipType')"
            [ngClass]="{'is-invalid' : unmarriedRelationshipTypeOther && unmarriedRelationshipTypeOther.touched && unmarriedRelationshipTypeOther.invalid}"
            [required]="isRequired('borrower.unmarriedRelationshipTypeOther')"/>
        </div>
      }
      @if (showUnmarriedPartnerDetails && !isHidden('borrower.unmarriedRelationshipState')) {
        <div class="col-md-3 fv-row">
          <label class="form-label" [ngClass]="{'required': isRequired('borrower.unmarriedRelationshipState')}">{{getLabel('borrower.unmarriedRelationshipState', t('wizard.myInfo.relationshipState'))}}</label>
          <select class="form-select form-select-solid" data-control="select2" name="unmarriedRelationshipState_{{componentId}}"
            [(ngModel)]="borrower.unmarriedRelationshipState" #unmarriedRelationshipState="ngModel"
            [ngClass]="{'is-invalid' : unmarriedRelationshipState && unmarriedRelationshipState.touched && unmarriedRelationshipState.invalid}"
            [required]="isRequired('borrower.unmarriedRelationshipState')"
            [attr.data-placeholder]="t('common.selectOne')">
            <option [ngValue]="null">{{ t('common.selectOne') }}</option>
            @for (st of usStates; track st.value) {
              <option [ngValue]="st.value">{{st.name}}</option>
            }
          </select>
        </div>
      }
    </div>
    <div class="row" [ngClass]="{'mb-5': !isMobile}">
      @if (!isHidden('borrower.dateOfBirth') && !hideCoBorrowerPrivateFields) {
        <div class="col-md-3 fv-row">
          <label class="form-label" [ngClass]="{'required': isRequired('borrower.dateOfBirth')}">{{getLabel('borrower.dateOfBirth', t('wizard.borrowerInfo.birthDate'))}}</label>
          <div class="position-relative d-flex align-items-center">
            <input class="form-control form-control-solid flatpickr-disabled" matInput mask="00/00/0000" [showMaskTyped]="true"
              [specialCharacters]="[ '/' ]" [dropSpecialCharacters]="false" datePicker #birthDate="ngModel" inputmode="numeric"
              [(ngModel)]="borrower.dateOfBirth" placeholder="" name="birthDate{{borrower.borrowerId}}" ngControl="birthDate" id="birthDate{{borrower.borrowerId}}"
              [ngClass]="{'is-invalid' : birthDate && birthDate.touched && birthDate.invalid}"
              [required]="isRequired('borrower.dateOfBirth')"/>
          </div>
        </div>
      }
      @if (!isHidden('borrower.socialSecNum') && !hideCoBorrowerPrivateFields) {
        <div class="col-md-3 fv-row">
          <label class="form-label" [ngClass]="{'required': isRequired('borrower.socialSecNum')}">{{getLabel('borrower.socialSecNum', t('wizard.borrowerInfo.ssn'))}}</label>
          <div class="position-relative d-flex align-items-center">
            <input class="form-control form-control-solid" matInput mask="000-00-0000" [showMaskTyped]="true"
              [(ngModel)]="borrower.socialSecNum" #socialSecNum="ngModel" [specialCharacters]="[ '-' ]"
              [dropSpecialCharacters]="false" [patterns]="ssnPattern" [placeholder]="t('wizard.borrowerInfo.ssn')" name="ssn" id="ssn"
              [required]="isRequired('borrower.socialSecNum')" [ngClass]="{'is-invalid' : socialSecNum && socialSecNum.touched && socialSecNum.invalid}" />
          </div>
        </div>
      }
      @if (!isHidden('borrower.declarations.residenceStatus') && !hideCoBorrowerPrivateFields) {
        <div class="col-md-3 fv-row">
          <label class="form-label" [ngClass]="{'required': isRequired('borrower.declarations.residenceStatus')}">{{getLabel('borrower.declarations.residenceStatus', t('wizard.borrowerInfo.citizenship'))}}</label>
          <select class="form-select form-select-solid" data-control="select2" name="citizenship"
            [(ngModel)]="borrower.declarations!.residenceStatus" #residenceStatus="ngModel"
            [ngClass]="{'is-invalid' : residenceStatus && residenceStatus.touched && residenceStatus.invalid}"
            [required]="isRequired('borrower.declarations.residenceStatus')">
            <option [ngValue]="null" disabled>{{ t('common.selectOne') }}</option>
            <option value="USCitizen">{{ t('wizard.borrowerInfo.usCitizen') }}</option>
            <option value="PermanentResident">{{ t('wizard.borrowerInfo.permanentResident') }}</option>
            <option value="NonPermanentResidentAlien">{{ t('wizard.borrowerInfo.nonPermanentResidentAlien') }}</option>
          </select>
        </div>
      }
      @if (!isHidden('borrower.languagePreference') && !hideCoBorrowerPrivateFields) {
        <div class="col-md-3 fv-row">
          <label class="form-label" [ngClass]="{'required': isRequired('borrower.languagePreference')}">{{getLabel('borrower.languagePreference', t('wizard.borrowerInfo.languagePreference'))}}</label>
          <select class="form-select form-select-solid" data-control="select2" name="languagePreference"
            [(ngModel)]="borrower.languagePreference" (ngModelChange)="onLanguagePreferenceChanged()" #languagePreference="ngModel"
            [ngClass]="{'is-invalid' : languagePreference && languagePreference.touched && languagePreference.invalid}"
            [required]="isRequired('borrower.languagePreference')">
            <option [ngValue]="null" disabled>{{ t('common.selectOne') }}</option>
            @for (lang of languagePreferenceOptions; track lang.value) {
              <option [ngValue]="lang.value">{{ t('enums.language.' + lang.value) }}</option>
            }
          </select>
        </div>
      }
    </div>
    <div class="row mb-5 rounded p-4"
      [ngClass]="{
        'mt-10': !isMobile,
        'is-invalid' : mainBorrowerWillApplyForMeQuestion && mainBorrowerWillApplyForMeQuestion.touched && mainBorrowerWillApplyForMeQuestion.invalid,
        'border' : mainBorrowerWillApplyForMeQuestion && mainBorrowerWillApplyForMeQuestion.touched && mainBorrowerWillApplyForMeQuestion.invalid,
        'border-danger' : mainBorrowerWillApplyForMeQuestion && mainBorrowerWillApplyForMeQuestion.touched && mainBorrowerWillApplyForMeQuestion.invalid
      }">
      <div class="col-sm-6 fs-6 text-dark" style="padding-top: 4px;">{{ t('wizard.borrowerInfo.willYouFillOutApplication') }}
      </div>
      <div class="col-md-2" [ngClass]="{'mt-2': isMobile}">
        <div class="d-flex">
          <div class="form-check form-check-custom form-check-solid">
            <input
              class="form-check-input"
              name="willYouBeApplyingForCoBorrowerQuestion"
              required
              [value]="true"
              type="radio"
              id="aYes"
              [(ngModel)]="mainBorrowerWillApplyForMe" #mainBorrowerWillApplyForMeQuestion="ngModel"
              (ngModelChange)="onMainBorrowerWillApplyForMeChanged($event)"/>
            <label style="padding-right: 6px;" class="form-check-label" for="aYes">{{ t('common.yes') }}</label>
          </div>
          <div class="form-check form-check-custom form-check-solid ms-8">
            <input
              class="form-check-input"
              name="willYouBeApplyingForCoBorrowerQuestion"
              required
              [value]="false"
              type="radio"
              id="aNo"
              [(ngModel)]="mainBorrowerWillApplyForMe" #mainBorrowerWillApplyForMeQuestion="ngModel"
              (ngModelChange)="onMainBorrowerWillApplyForMeChanged($event)"/>
            <label style="padding-right: 6px;" class="form-check-label" for="aNo">{{ t('common.no') }}</label>
          </div>
        </div>
      </div>
    </div>
    <div class="invalid-feedback">{{ t('wizard.borrowerInfo.specifyIfYouWillComplete') }}</div>
    @if (mainBorrowerWillApplyForMe != null) {
      <div class="row mb-3 rounded p-4"
        [ngClass]="{
          'mt-5': !isMobile,
          'is-invalid' : areYouMarriedToThisPersonQuestion && areYouMarriedToThisPersonQuestion.touched && areYouMarriedToThisPersonQuestion.invalid,
          'border' : areYouMarriedToThisPersonQuestion && areYouMarriedToThisPersonQuestion.touched && areYouMarriedToThisPersonQuestion.invalid,
          'border-danger' : areYouMarriedToThisPersonQuestion && areYouMarriedToThisPersonQuestion.touched && areYouMarriedToThisPersonQuestion.invalid
        }">
        <div class="col-sm-6 fs-6 text-dark" style="padding-top: 4px;">{{ t('wizard.borrowerInfo.areYouMarriedToThisPerson') }}
        </div>
        <div class="col-md-2" [ngClass]="{'mt-2': isMobile}">
          <div class="d-flex">
            <div class="form-check form-check-custom form-check-solid">
              <input
                class="form-check-input"
                name="areYouMarriedToThisPersonQuestion"
                required
                [value]="true"
                type="radio"
                id="marriedYes"
                [(ngModel)]="borrower.isMarriedToPrimaryBorrower" #areYouMarriedToThisPersonQuestion="ngModel"
                (ngModelChange)="onMainBorrowerIsMarriedToBorrowerChanged($event)"/>
              <label style="padding-right: 6px;" class="form-check-label" for="aYes">{{ t('common.yes') }}</label>
            </div>
            <div class="form-check form-check-custom form-check-solid ms-8">
              <input
                class="form-check-input"
                name="areYouMarriedToThisPersonQuestion"
                required
                [value]="false"
                type="radio"
                id="marriedNo"
                [(ngModel)]="borrower.isMarriedToPrimaryBorrower" #areYouMarriedToThisPersonQuestion="ngModel"
                (ngModelChange)="onMainBorrowerIsMarriedToBorrowerChanged($event)"/>
              <label style="padding-right: 6px;" class="form-check-label" for="aNo">{{ t('common.no') }}</label>
            </div>
          </div>
        </div>
      </div>
    }
    <div class="invalid-feedback">{{ t('wizard.borrowerInfo.specifyIfMarried') }}</div>
  </div>
</form>
</ng-container>
